export default {
  title: {
    receipt: 'ใบเสร็จรับเงิน',
    receiptEN: 'Receipt',
    refund: 'ใบคืนเงิน',
    refundEN: 'Refund',
    cancelRefund: 'ยกเลิกออเดอร์/คืนเงิน',
    order: 'ออเดอร์'
  },
  headers: {
    pricePerUnit: 'ราคาต่อหน่วย',
    qty: 'จำนวน',
    opdNo: 'หมายเลข OPD',
    drugdispensing: 'สถานะการจ่ายยา',
    orderStatus: 'สถานะออเดอร์'
  },
  label: {
    sumInService: 'รวมในราคาบริการ',
    noSumInService: 'ไม่รวมในราคาบริการ',
    sumDiscount: 'ส่วนลดรวม',
    totalDiscount: 'รวมส่วนลดทั้งหมด',
    allTotal: 'ยอดรวมทั้งหมด',
    netTotal: 'ยอดรวมสุทธิ',
    beforeVAT: 'ก่อน VAT',
    clear: 'เคลียร์',
    pauseBill: 'พักบิล',
    pay: 'ชำระเงิน',
    qty: 'จำนวน',
    receiptId: 'เลขที่ใบเสร็จ',
    fnameLname: 'ชื่อ - นามสกุล',
    printDate: 'วันที่พิมพ์',
    counter: 'เคาน์เตอร์',
    pricePerUnit: 'ราคาต่อหน่วย',
    pack: 'ห่อ',
    episode: 'ครั้ง',
    transfer: 'โอนเงิน',
    creditcard: 'เครดิต',
    cash: 'เงินสด',
    payee: 'เจ้าหน้าที่การเงิน',
    serviceReceiver: 'ชื่อผู้รับบริการ',
    medicationRecipient: 'ผู้รับยา',
    orderId: 'รหัสออเดอร์',
    backToPOS: 'กลับหน้า แคชเชียร์',
    payment: 'วิธีชำระเงิน',
    noSpecified: 'ไม่ระบุ',
    specified: 'ระบุ',
    taxNo: 'หมายเลขผู้เสียภาษี',
    taxName: 'ชื่อผู้เสียภาษี',
    drugStatus: 'สถานะการจัดยา',
    organizer: 'ผู้จัดยา',
    value: 'มูลค่า',
    refundList: 'รายการคืน',
    refundTotal: 'ยอดคืนรวมสุทธิ',
    printLabels: 'พิมพ์ฉลากยา',
    medicationLabelInfo: 'ข้อมูลสำหรับฉลากยา'
  },
  placeholder: {
    searchPatientOPD: 'ค้นหาคนไข้, หมายเลข OPD',
    selectBank: 'เลือกธนาคาร',
    taxNo: 'กรอกหมายเลขผู้เสียภาษี',
    taxName: 'กรอกชื่อผู้เสียภาษี'
  },
  alert: {
    plzAddPOS: 'โปรดเพิ่มรายการก่อนที่จะสร้างคำสั่งซื้อ.',
    plzAddCustomer: 'โปรดเลือกลูกค้าก่อนที่จะสร้างคำสั่งซื้อ.',
    confirmCancelTitle: 'ยืนยันการยกเลิกออเดอร์',
    confirmCancelSubtitle: 'ยืนยันการยกเลิกออเดอร์',
    deleted: 'ยกเลิกออเดอร์สำเร็จ !',
    plzEnterCorectTaxNo: 'โปรดกรอกเลขประจำตัวผู้เสียภาษีให้ถูกต้อง',
    plzEnterCorectTaxNo13: 'โปรดกรอกเลขประจำตัวผู้เสียภาษีให้ครบ 13 หลัก',
    confirmRefundTitle: 'ยืนยันการคืนสินค้า/คืนเงิน'
  },
  status: {
    drugDispensingStatus: 'สถานะการจ่ายยา',
    all: 'ทั้งหมด',
    wait: 'รอชำระเงิน',
    received: 'จ่ายแล้ว',
    refund: 'คืนเงิน',
    cancel: 'ยกเลิก',
    paid: 'ชำระเงินแล้ว'
  },
  toolTip: {
    createNew: 'สร้างใหม่',
    seeOrderDetail: 'ดูข้อมูลออเดอร์',
    returnProduct: 'คืนสินค้า',
    panel: 'แผง'

  },
  bank: {
    kasikorn: 'กสิกรไทย',
    scb: 'ไทยพาณิชย์',
    krungthai: 'กรุงไทย',
    tmb: 'ทหารไทย',
    gsb: 'ออมสิน',
    bangkok: 'กรุงเทพ',
    bay: 'กรุงศรีอยุธยา',
    tbank: 'ธนชาต',
    uob: 'ยูโอบี',
    kk: 'เกียรตินาคินภัทร',
    cimb: 'ซีไอเอ็มบีไทย',
    tisco: 'ทิสโก้',
    lhb: 'แลนด์ แอนด์ เฮาส์',
    ghb: 'อาคารสงเคราะห์',
    baac: 'เพื่อการเกษตรและสหกรณ์การเกษตร',
    islamic: 'อิสลามแห่งประเทศไทย'
  }
}
